import { useState, useEffect } from "react";

interface UseScrollDetectionOptions {
  threshold?: number; // Scroll threshold in pixels
  onScroll?: (scrolled: boolean) => void; // Callback when scroll state changes
}

/**
 * Custom hook for detecting page scroll position
 * @param options Configuration options
 * @returns Whether the page has been scrolled past the threshold
 */
export const useScrollDetection = (
  options: UseScrollDetectionOptions = {}
): boolean => {
  const { threshold = 100, onScroll } = options;
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const hasScrolled = window.scrollY > threshold;
      setScrolled(hasScrolled);
      onScroll?.(hasScrolled);
    };

    // Initial check
    handleScroll();

    // Attach listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [threshold, onScroll]);

  return scrolled;
};

